/**
 * Formats a raw rupee number en-IN, with negatives in the Indian bracketed style
 * (e.g. -77710000 -> "(7,77,10,000)"). Amounts arrive raw over the wire (D11) —
 * all unit conversion/formatting for Reconciliations is client-side.
 */
export function inrAmount(value: number): string {
    const formatted = Math.abs(value).toLocaleString('en-IN');
    return value < 0 ? `(${formatted})` : formatted;
}
